import { AdminUserContactsInfoModel } from "./user_contacts_info_model.js"
import { RawAdminUserModel } from "./user_model.js";

class RawAdminContactsUserModel extends RawAdminUserModel {

  rawFormFields(item = undefined) {
    return [
      {
        name: "personalInfo",
        type: "nestedModel",
        model: AdminUserContactsInfoModel,
        weight: 12,
      }
    ]
  }
}
const AdminContactsUserModel = new RawAdminContactsUserModel();

export { RawAdminContactsUserModel, AdminContactsUserModel }
